import React from "react";
import { Outlet, useParams } from "react-router-dom";
import * as _ from "lodash";
import "./index.scss";
import Tabs from "../../../components/core/tab";
import { useTranslation } from "react-i18next";

const ProfileInfo = () => {
  const { t } = useTranslation();
  const params = useParams();
  const profileId = _.get(params, "id");
  const configTabs = {
    isPath: true,
    tabs: [
      { label: t("settings.profile.initial_information"), path: `/profile/${profileId}/info` },
      {
        label: t("settings.profile.business_hours"),
        path: `/profile/${profileId}/info/business-hours`,
      },
    ],
  };

  return (
    <div className="container">
      <div>
        <div className="row header-title mb-4">
          <div className="col-lg-6">
            <h3 className="color-pri">
              {t("settings.profile.initial_information")}
            </h3>
          </div>
          <div className="col-lg-6 text-start text-lg-end align-self-center">
            <a className="default-link" href={`#/profile/${profileId}/detail`}>
              <i className="fa fa-arrow-left"></i>{" "}
              {t("settings.profile.profile_detail")}
            </a>
          </div>
        </div>
        <Tabs config={configTabs} />
        <br />
        <div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;
